import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.outstanding_view.topupPendingTitle',
        defaultMessage: 'Additional funds requested'
    },
    description: {
        id: '_.outstanding_view.topupPending',
        defaultMessage:
            "Thanks for your application for an additional {amount}. We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
    },
    fallbackDescription: {
        id: '_.outstanding_view.topupPendingFallbackDescription',
        defaultMessage:
            "Thanks for your application for a top up to a credit limit of {amount}. We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
    },
    ctaText: {
        id: '_.outstanding_view.changeTopRequest',
        defaultMessage: 'Change request'
    },
    docsRequiredTitle: {
        id: '_.outstanding_view.documentsRequired',
        defaultMessage: 'Documents Required'
    },
    docsRequiredDescription: {
        id: '_.outstanding_view.documentsRequiredDescription',
        defaultMessage:
            'We need some documents from you to complete your top up request'
    },
    docsRequiredCtaText: {
        id: '_.outstanding_view.uploadDocumentsCTA',
        defaultMessage: 'Upload documents'
    }
});
